<template>
    <div>
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @returnId="returnId" @addCreateRule="addCreateRule" pageName="BudgetManage" ref="table"
            @isPageSmall="isPageSmall"></common-table>
        <el-drawer :visible.sync="showAddCreateRulePopup" :size="pageSmall ? '100%' : '50%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter">
                    创建规则
                    <i class="el-icon-close" @click="closeRulePopup"></i>
                </div>
                <div class="setRuleContent">
                    <div class="oe-drawer-guide">
                        <guide-panel dense
                            title="预算提醒规则说明"
                            summary="这张表单用于监控账户或计划的预算消耗进度。当消耗达到你设定的预算百分比时，系统会发送提醒，帮助你及时介入。"
                            icon="el-icon-money"
                            :points="[
                                '这里关注的是预算使用进度，不是余额本身。',
                                '账户维度适合看整体预算节奏，计划维度适合盯重点计划。',
                                '建议先从 70%、85%、95% 这类分层阈值开始配置。'
                            ]"
                        />
                    </div>
                    <div class="oe-drawer-form-row" :class="pageSmall ? 'fs14' : ''">
                        <span class="oe-drawer-form-label">规则名称</span>
                        <el-input class="input250 w300" v-model="ruleName" placeholder="请输入规则名称" />
                    </div>

                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">请选择代理</span>
                        <el-select size="medium" v-model="selectAgentId" placeholder="请选择代理" clearable filterable>
                            <el-option v-for="(option, index) in agentList" :key="index" :label="option.username"
                                :value="option.id" />
                        </el-select>
                    </div>
                    <div class="monitorWayBox flex alcentr">
                        <!-- <div class="pb10 "> -->
                        <span :class="pageSmall ? ' fs16' : ' fs18'">监控方式：</span>
                        <!-- </div> -->
                        <div class=" flex alcenter flex_grow_1">
                            <div class="way_box text-center mr20"
                                :class="{ 'active_way_box': activeWayBoxIndex == index }"
                                v-for="(item, index) in monitorWayList" :key="index" @click="goSelectMonitorWay(index)">
                                <div class="font-bold">
                                    {{ item.wayName }}
                                </div>
                                <div class="way_info pt10" :class="{ 'active_way_box': activeWayBoxIndex == index }">
                                    {{ item.info }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section oe-drawer-section--tight">
                        <div class="flex alcenter" v-if="!activeWayBoxIndex">
                            <el-input v-model="searchKeyWord" @clear="searchAccountList = []; isSearching = false"
                                clearable placeholder="搜索账户名称或ID" size="medium" class="handle-input2  mb-10" />
                            <el-button class="mb-10 fs18 elBtn" type="primary" size="small"
                                @click="goSearchMonitorList(0)">
                                搜索
                            </el-button>
                        </div>
                        <div v-else-if="activeWayBoxIndex == 1">
                            <div class="pt5 pb20 pr10">
                                监控目标
                                <el-select class="pl10 input250" v-model="selectedAccount" @change="getPlanList"
                                    placeholder="请选择账户">
                                    <el-option v-for="(item, index) in accountList" :key="index" :label="item.name"
                                        :value="item.advertiserId">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="flex alcenter">
                                <el-input v-model="searchKeyWord" @clear="searchAccountList = []; isSearching = false"
                                    clearable placeholder="搜索计划名称或ID" size="medium" class="handle-input2  mb-10" />
                                <el-button class="mb-10 fs18 elBtn" type="primary" size="small"
                                    @click="goSearchMonitorList(1)">
                                    搜索
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox pt5">
                        <div class=" ">
                            <div class="selectAccountBox ">
                                <div class="pb10 fs14" v-if="activeWayBoxIndex == 2">
                                    <i class="el-icon-warning c_666"></i>
                                    只显示投放中的计划。如果列表没有某计划，请确认该计划状态为投放中。
                                </div>
                                <div class="selectTitleBox flex alcenter">
                                    <div class="leftTitle flex alcenter">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                            @change="handleCheckAllChange">
                                        </el-checkbox>
                                        <span class="pr5 pl10 " :class="pageSmall ? 'fs14' : ' fs18'">请选择{{
                                            activeWayBoxIndex ? '计划' : '账户' }}</span> <span v-if="monitorList.length"
                                            class="pr5" :class="pageSmall ? 'fs14' : ' fs18'">({{
                                                monitorList.length
                                            }})</span>
                                        <el-tooltip class="item" effect="dark"
                                            :content="activeWayBoxIndex ? activeWayBoxIndex == 2 ? '最多展示前200条，如果列表没有某条数据，请使用搜索减小范围' : '最多展示前100条，如果列表没有某条数据，请使用搜索减小范围' : '最多展示前200条，如果列表没有某条数据，请使用搜索减小范围'"
                                            placement="top">
                                            <i class="el-icon-question mt5"></i>
                                        </el-tooltip>
                                    </div>
                                    <div class="rightTitle flex-between">
                                        <div :class="pageSmall ? 'fs14' : ' fs18'">
                                            已选{{ activeWayBoxIndex ? '计划' : '账户' }}
                                            <span v-if="selectedMonitorList.length">({{ selectedMonitorList.length }}
                                                )</span>
                                        </div>
                                        <div class="c_primary" v-if="selectedMonitorList.length"
                                            @click="deleteSelectedMonitorList('')">
                                            清空
                                        </div>
                                    </div>

                                </div>
                                <div class="selectContentBox">
                                    <div class="flex">
                                        <div class="left" v-loading="loading">
                                            <el-checkbox-group v-model="checkedAccount"
                                                @change="handleCheckedCitiesChange">
                                                <div class="flex alcenter  pb20"
                                                    v-for="(item, index) in isSearching ? searchMonitorList : monitorList"
                                                    :key="index">
                                                    <el-checkbox :label="item">
                                                        <div class="pl5 ">
                                                            <div
                                                                :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                                {{ item.name }}</div>
                                                            <div class="c_999 " :class="pageSmall ? 'fs12' : ' fs14'">
                                                                ID:{{ activeWayBoxIndex ? item.adId : item.advertiserId
                                                                }}
                                                            </div>
                                                        </div>
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                            <div class="pt50 nodata flex-center" v-if="!monitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                        <div class="left p5" v-loading="loading">
                                            <div class="flex-between alcenter selectedAccountBox pb20 mb10"
                                                v-for="(item, index) in selectedMonitorList" :key="index">
                                                <div class="pl5 ">
                                                    <div
                                                        :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                        {{ item.name }}</div>
                                                    <div class="c_999 " :class="pageSmall ? 'fs12' : ' fs14'">
                                                        ID:{{ activeWayBoxIndex ? item.adId : item.advertiserId }}
                                                    </div>
                                                </div>
                                                <i class="el-icon-error" @click="deleteSelectedMonitorList(index)"></i>
                                            </div>
                                            <div class="pt50 nodata flex-center" v-if="!selectedMonitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section">
                        <div class="oe-drawer-block-title">计划白名单</div>
                        <el-select v-model="planWhiteList" multiple filterable allow-create default-first-option
                            clearable collapse-tags class="input400 input_h35"
                            @change="planWhiteList = normalizePlanWhiteList(planWhiteList)"
                            placeholder="输入计划ID后回车确认；已加载计划会自动出现在下拉中">
                            <el-option v-for="item in planWhiteListOptions" :key="item.value"
                                :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <div class="pt10 c_999">
                            命中白名单的计划不会被当前规则处理；未加载到的计划也可以直接输入计划ID。
                        </div>
                    </div>
                    <div class="oe-drawer-section">
                        执行条件：所监控计划当日消耗达到日预算的
                        <el-input class="w150 input150" v-model="balanceMin" placeholder="请输入" suffix-icon="元"
                            size="medium" />%
                    </div>
                    <div class="oe-drawer-section flex alcenter">
                        <span class="pr20 ">
                            执行动作
                        </span>
                        <div>
                            <el-checkbox :style="{ 'transform: scale(1.2);': !pageSmall }" v-model="wxNotice">
                                微信通知
                            </el-checkbox>
                            <div v-if="!wxNotice" class="c_ff3939 pt10">
                                请选择通知方式
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section flex" v-if="wxNotice">
                        <span class="pr10 pt10">
                            微信联系人
                        </span>
                        <div>
                            <div>
                                <el-select :class="pageSmall ? 'input200' : 'w400 input400'" multiple
                                    v-model="wxContracts" filterable placeholder="请选择联系人">
                                    <el-option v-for="item in wxContractsOptions" :key="item.wechatName"
                                        :label="item.wechatName" :value="item.openId">
                                    </el-option>
                                </el-select>
                                <span class="pl20 c_primary" @click="goAddContrats">添加联系人</span>
                            </div>
                            <div class="flex alcenter flex_wrap pt10">
                                <el-switch class="mr10" :style="{ 'transform: scale(1.1);': !pageSmall }"
                                    v-model="isLimitWXNotice">
                                </el-switch>
                                限制通知频率，每条计划
                                <el-select v-model="wxNoticeTimeValue" :disabled="!isLimitWXNotice" class="ml5 input150"
                                    placeholder="请选择" :class="pageSmall ? 'mt20' : ''">
                                    <el-option v-for="(item, index) in wxNoticeTimeList" :key="index" :label="item.name"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <div :class="pageSmall ? 'mt20' : ''">
                                    内最多通知一次
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section oe-drawer-section--bottom">
                        <span>监控状态</span>
                        <el-select class="pl10 input250" v-model="monitorStatus" placeholder="请选择">
                            <el-option v-for="item in monitorStatusList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18 " round type="primary" size="small" @click="closeRulePopup">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18 " round type="primary" size="small" @click="goAddRule">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import GuidePanel from "@/components/GuidePanel/GuidePanel";
import {
    buildMonitorObjectInfo,
    buildPlanWhiteListOptions,
    normalizePlanWhiteList,
    parseMonitorObjectInfo,
} from "@/utils/smartRoiRuleFormHelper";

export default {
    name: 'BudgetManage',
    components: { CommonTable, GuidePanel },
    data() {
        return {
            agentList: [],
            selectAgentId: '',
            loading: false,
            balanceMin: '',
            searchKeyWord: '',
            isSearching: false,
            // 营销目标
            activeMarketingBox: 0,
            isWxNotice: false,
            // 监控目标
            monitorTarget: '',
            editData: {},

            accountPlanType: '推商品',
            accountPlanList: ['推商品', '推直播间'],
            adsValue: '通投广告',
            adsList: ['通投广告', '搜索广告', '商城广告'],
            monitorList: [],
            selectedMonitorList: [],
            planWhiteList: [],
            planWhiteListOptions: [],
            // monitorTargetList:[],

            // 执行内容
            // 1
            monitor1: true,
            durationValue: "当前时段",
            durationList: ['当前时段', '当日', '最近2天', '最近3天'],
            consumeMin: '',
            wholePayValue: '整体支付ROI',
            wholePayList: ['整体支付ROI', '整体成交订单数'],
            wholePayNum: '',
            improveValue: '百分比提高',
            improveList: ['提高', '百分比提高'],
            roiTargetMax: '',
            // 2
            isOpenWholePay: false,
            wholePayValue2: '整体支付ROI',
            consumeMax: 0,
            wholePayNum2: '',
            reduceValue: '百分比降低',
            reduceList: ['降低', '百分比降低'],


            activeWayBoxIndex: 0,
            searchAccountKeyWord: null,
            monitorWayList: [
                {
                    wayName: '账户',
                    info: '监控账户下所有计划'
                },
                // {
                //     wayName: '广告组',
                //     info: '监控广告组下所有计划'
                // },
                {
                    wayName: '计划',
                    info: '监控指定广告计划'
                },
            ],
            // 监控目标
            checkAll: false,
            checkedAccount: [],
            accountList: [],
            selectedAccountList: [],
            planFilterValue: '推商品',
            deliveryMethodValue: '投放方式：不限',
            deliveryMethodList: [{
                name: '投放方式：不限',
            }, {
                name: '控成本投放',
            }, {
                name: '放量投放',
            },],
            rangeValue: '当日',
            consumeValue: '消耗',
            rangeList: ['当日', '最近2天', '最近3天', '最近4天', '最近5天', '最近6天', '最近7天'],
            conditionValue: '所有',
            ordersValue: '整体成交订单数',
            compareValue: '小于等于',
            compareList: ['小于等于', '大于'],
            ordersList: [{
                name: '消耗',
                isDisable: true
            }, {
                name: '整体成交订单数',
                isDisable: true
            }, {
                name: '整体成交金额',
                isDisable: false
            }, {
                name: '整体支付ROI',
                isDisable: false
            }, {
                name: '整体成交订单成本',
                isDisable: false
            },],
            conditionList: ['任一', '所有'],

            // 执行动作
            executeValue: '立即执行',
            executeList: ['立即执行', '缓冲执行'],
            noticeValue: '仅通知',
            noticeList: ['仅通知', '仅关停', '关停且通知'],
            isLimitNotice: false,
            watchMinute: 5,

            // 执行时段
            activeTimePeriodBox: 0,
            timeSelectActiveList: [],

            // 监控状态
            monitorStatus: '启用',
            monitorStatusList: ['启用', '停用'],

            // 规则名称
            ruleName: '',


            isIndeterminate: true,
            showAddCreateRulePopup: false,
            selectIds: [],
            selectProductIds: [],
            visible: false,
            advertiserList: [],
            douyinIds: [],
            currentDouyinList: [],
            updateForm: {
                advertiserId: '',
                douyinId: ''
            },
            creatVisible: false,
            creatForm: {
                advertiserId: '',
                aweMeId: '',
                roi: '',
                budget: '',
                productId: ''
            },

            creatTaskVisible: false,
            creatTaskForm: {
                advertiserId: '',
                aweMeId: '',
                roi: '',
                budget: '',
                productId: ''
            },
            searchs: [{
                name: 'monitorStatus',
                placeholder: '监控状态',
                type: 'select',
                select: true,
                // selectUrl: '/oceanEngineAdvertiser/getAllInfo',
                selectData: [],
                selectValue: [{
                    value: '关闭',
                    key: 0
                }, {
                    value: '开启',
                    key: 1
                }]
            }, {
                name: 'createPerson',
                placeholder: '创建人',
                type: 'select',
                select: true,
                selectUrl: '/agent/getAll',
                selectData: [],
            }, {
                name: 'ruleName',
                placeholder: '规则名称',
                type: 'input'
            }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                get: '/smartRoiRules/listByCondition?intelligentRegulationType=3',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'status',  // 字段名
                label: '状态',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                status: true,  // 是否展示
            }, {
                field: 'ruleName',  // 字段名
                label: '规则名称',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'accountNum',  // 字段名
                label: '监控方式',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                tableType: 'monitorMode'
            }, {
                field: 'ruleInfo',  // 字段名
                label: '规则详情',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                width: 600
            }, {
                field: 'executeAction',  // 字段名
                label: '执行动作',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'createPerson',  // 字段名
                label: '创建人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,
            }],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    this.showAddCreateRulePopup = true
                    this.editData.id = row.id
                    this.editData.monitoringTime = row.executeContent.monitoringTime
                    this.monitorStatus = row.status ? '启用' : '停用'
                    // this.activeWayBoxIndex = JSON.parse(row.monitorType) - 1
                    this.balanceMin = row.executeContent.balanceMin
                    this.activeWayBoxIndex = row.monitorType - 1
                    if (!this.activeWayBoxIndex) {
                        this.monitorList = this.accountList
                        let arr = []
                        this.accountList.forEach((obj) => {
                            if (row.monitorObject.includes(obj.advertiserId)) {
                                arr.push(obj)
                            }
                        })
                        console.log(arr, this.accountList, row.monitorObject, '66666')
                        if (arr.length) {
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                        if (row.executeContent.monitorObjectInfo) {
                            const { planWhiteList } = parseMonitorObjectInfo(row.executeContent.monitorObjectInfo)
                            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
                            this.mergePlanWhiteListOptions(
                                this.planWhiteList.map(value => ({ adId: value, name: value }))
                            )
                        }
                    } else {
                        if (row.monitorAdvertiserId) {
                            this.monitorAdvertiserId = row.monitorAdvertiserId
                            if (this.accountList.length) {
                                this.selectedAccount = JSON.parse(this.monitorAdvertiserId)
                            }
                            if (row.executeContent.monitorObjectInfo) {
                                this.restoreMonitorObjectInfo(row.executeContent.monitorObjectInfo)
                            }
                            this.monitorList = []
                            this.getPlanList()

                        }
                        console.log('11111111', this.activeWayBoxIndex, this.selectedAccount)
                    }
                    this.ruleName = row.ruleName
                    this.selectAgentId = row.userId
                    this.wxContracts = row.noticeConfig && row.noticeConfig.wxNumber
                    if (row.noticeConfig && row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }

                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    this.$axios.post({
                        url: 'smartRoiRules/delete/' + row.id,
                        success: (res) => {
                            // this.loading = false
                            console.log('333', res)
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                // this.showAddCreateRulePopup = false
                                this.$refs.table.getData()
                            } else {
                                // this.$message.error(res.msg || '出错了')

                            }
                        },
                        error: () => {
                            this.loading = false
                            this.$message.error('出错了')
                        },
                    })
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '日志',
                handle: (row) => {
                    console.log(row)
                    console.log(row)
                    this.$router.push({
                        path: '/qdd/admin/SmartRoiRuleLogs.html',
                        query: { id: row.id, getLog: true }
                    })
                }
            }],
            buttons: [
                {

                }
            ],
            pageSmall: false,
            // 通知方式
            wxNotice: true,
            wxContracts: [],
            wxContractsOptions: [],
            isLimitWXNotice: false,
            wxNoticeTimeValue: 30,
            wxNoticeTimeList: [{
                name: '每30分钟',
                value: 30
            }, {
                name: '每1小时',
                value: 60
            }, {
                name: '每3小时',
                value: 180
            }, {
                name: '每6小时',
                value: 360
            }],
        }
    },
    mounted() {
        // window.addEventListener('scroll', this.handleScroll);
        // 初始化抖音账号列表为空
        this.getADAccountList()
        this.getWxcontractsList()
        this.getAgentList()
    },

    beforeDestroy() {
        // window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        normalizePlanWhiteList,
        getAgentList() {
            this.$axios.post({
                url: '/agent/getAll',
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.agentList = res.data
                        console.log('333', this.agentList)

                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                    //          
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        goAddContrats() {
            this.showAddCreateRulePopup = false
            setTimeout(() => {
                this.$router.push({
                    path: '/qdd/admin/contacts.html',
                })
            }, 1)
        },

        getWxcontractsList() {
            this.$axios.post({
                url: '/wechatUser/getAll',
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.wxContractsOptions = res.data
                    } else {
                        this.$message.error(res.msg || '出错了')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
        mergePlanWhiteListOptions(list = []) {
            const nextOptions = buildPlanWhiteListOptions(list)
            if (!nextOptions.length) {
                return
            }
            const optionMap = new Map(this.planWhiteListOptions.map(item => [item.value, item]))
            nextOptions.forEach((item) => {
                optionMap.set(item.value, item)
            })
            this.planWhiteListOptions = Array.from(optionMap.values())
        },
        restoreMonitorObjectInfo(raw) {
            const { selectedMonitorList, planWhiteList } = parseMonitorObjectInfo(raw)
            this.selectedMonitorList = selectedMonitorList
            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
            this.mergePlanWhiteListOptions(
                this.planWhiteList.map(value => ({ adId: value, name: value }))
            )
        },
        closeRulePopup() {
            this.editData = {}
            this.activeWayBoxIndex = 0

            this.isSearching = false
            this.balanceMin = ''
            this.searchKeyWord = ''
            this.checkAll = false
            this.checkedAccount = []
            this.selectedMonitorList = []
            this.planWhiteList = []
            this.planWhiteListOptions = []
            this.monitorList = this.accountList
            this.wxContracts = []
            this.wxNotice = true
            this.isLimitWXNotice = false
            this.wxNoticeTimeValue = 30
            this.monitorStatus = '启用'
            this.ruleName = ''
            this.selectAgentId = ''
            this.showAddCreateRulePopup = false
        },
        inputBlur(e, index) {
            console.log(e, index, 'inputBlur')
            if (e <= this.stairsList[index].minValue) {
                this.$set(this.stairsList[index], 'wholePayNum', JSON.parse(this.stairsList[index].minValue) + 0.01)
            }
        },
        ordersChange() {
            // console.log(this.executeConditionList)
            let list = []
            this.executeConditionList.forEach((obj) => {
                list.push(obj.ordersValue)
            })
            this.ordersList.forEach((obj) => {
                if (list.includes(obj.name)) {
                    obj.disabled = true
                    // this.$set(this.ordersList)
                } else {
                    obj.disabled = false

                }
            })
        },
        // 处理选择时间
        pickData(e) {
            console.log(e)
            if (e) {
                console.log(e, '233')
                console.log(this.selectData, '233')
                const year_start = e[0].getFullYear()
                const month_start = String(e[0].getMonth() + 1).padStart(2, '0')
                const day_start = String(e[0].getDate()).padStart(2, '0')
                this.startTime = `${year_start}-${month_start}-${day_start}`
                const inputDate = new Date(e[1])
                this.endTime = this.processDate(inputDate)
                console.log(this.startTime, this.endTime, '233')
            } else {
                this.startTime = ''
                this.endTime = ''
                console.log(this.startTime, this.endTime, '233')
            }
            if (this.selectedAccount) {
                this.getPlanList()
            }
        },
        processDate(targetDate) {
            const now = new Date();
            // 创建目标日期的纯日期部分（去除时间）
            const targetDateOnly = new Date(
                targetDate.getFullYear(),
                targetDate.getMonth(),
                targetDate.getDate()
            );

            // 创建当前日期的纯日期部分（去除时间）
            const todayOnly = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
            );

            console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
            if (targetDateOnly.getTime() === todayOnly.getTime()) {
                // 如果是今天：返回当前完整时间（年月日时分秒）

                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')
                // const hours = String(now.getHours()).padStart(2, '0')
                // const minutes = String(now.getMinutes()).padStart(2, '0')
                // const seconds = String(now.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day}`
            } else {
                const year_end = targetDate.getFullYear()
                const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
                const day_end = String(targetDate.getDate()).padStart(2, '0')
                return `${year_end}-${month_end}-${day_end}`
            }
        },
        goAddRule() {


            if (!this.ruleName) {
                this.$message.error('请输入规则名称')
                return
            }
            if (!this.selectAgentId) {
                this.$message.error('请选择代理')
                return
            }
            if (!this.selectedMonitorList.length) {
                let name = this.activeWayBoxIndex ? '计划' : '账户'
                this.$message.error('请选择' + name)
                return
            }
            if (!this.balanceMin) {
                this.$message.error('请完善执行条件')
                return

            }


            if (!this.wxContracts.length) {
                this.$message.error('请选择联系人')
                return

            }


            let ids = []
            this.selectedMonitorList.forEach((obj) => {
                if (!this.activeWayBoxIndex) {
                    ids.push(obj.advertiserId)
                } else if (this.activeWayBoxIndex == 1) {
                    ids.push(obj.adId)
                } else if (this.activeWayBoxIndex == 2) {
                    ids.push(obj.id)
                } else if (this.activeWayBoxIndex == 3) {
                    ids.push(obj.id)
                }
            })
            // console.log(ids)
            let noticeConfig = {  //通知设置，如通知设置传0则为不通知
                wxNumber: this.wxContracts,  //通知微信号
                interval: this.isLimitWXNotice ? this.wxNoticeTimeValue : 0  //限制的通知频率，为0则不限制
            }

            let executeContent = {
                balanceMin: this.balanceMin,//余额小于多少
                monitorObjectInfo: buildMonitorObjectInfo(this.selectedMonitorList, this.planWhiteList),
            }
            const now = new Date();
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            let monitoringTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            if (this.editData.monitoringTime) {
                executeContent.monitoringTime = this.editData.monitoringTime
            } else {
                executeContent.monitoringTime = monitoringTime
            }
            console.log(executeContent)
            let data = {
                userId: this.selectAgentId,
                ruleName: this.ruleName,
                marketingTarget: 0,
                monitorType: this.activeWayBoxIndex + 1,
                status: 1,
                monitorObject: ids,
                planWhitelist: JSON.stringify(this.planWhiteList),
                monitorObjectInfo: this.selectedMonitorList,
                executeContent: JSON.stringify(executeContent),
                noticeConfig: JSON.stringify(noticeConfig),
                intelligentRegulationType: 3,
                monitorAdvertiserId: this.selectedAccount,
            }
            console.log(data)
            let url
            if (this.editData.id) {
                data.id = this.editData.id
                url = 'smartRoiRules/update'
            } else {
                url = 'smartRoiRules/add'
            }
            this.$axios.post({
                url: url,
                data,
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.closeRulePopup()
                        this.$refs.table.getData()
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }


                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })


        },
        handleCheckAllChange(e) {
            console.log(e)
            this.checkedAccount = e ? this.monitorList : []
            this.selectedMonitorList = this.checkedAccount
            this.isIndeterminate = false
            console.log(this.isIndeterminate, 'this.isIndeterminate')
        },
        handleCheckedCitiesChange(e) {
            console.log(e)
            this.selectedMonitorList = e
            this.checkAll = e.length === this.monitorList.length
            this.isIndeterminate = e.length > 0 && e.length < this.monitorList.length
        },
        deleteSelectedMonitorList(index) {
            console.log(index, index)
            if (index === '') {
                this.handleCheckAllChange(false)
            } else {
                this.checkedAccount = this.checkedAccount.slice(0, index).concat(this.checkedAccount.slice(index + 1));
                this.selectedMonitorList = this.checkedAccount
            }
            this.checkAll = false
        },
        goSelectMonitorWay(index) {
            this.activeWayBoxIndex = index
            this.monitorList = []
            this.selectedMonitorList = []
            this.selectedAccount = ''
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.checkedAccount = []
            this.checkAll = false
            this.planWhiteList = []
            this.planWhiteListOptions = []

            if (!this.activeWayBoxIndex) {
                this.getADAccountList()

            }
        },
        goSearchMonitorList(type) {
            if (!this.searchKeyWord) return
            this.isSearching = true
            this.searchMonitorList = []
            if (!type) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.advertiserId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 1) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.adId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            }
            console.log(this.searchMonitorList)

        },
        getADAccountList() {
            this.$axios.post({
                url: '/oceanEngineAdvertiser/getAllInfo',
                success: (res) => {
                    console.log('333', res)
                    this.accountList = res.data
                    this.monitorList = this.accountList
                },
                error: () => {
                    this.$message.error('出错了')
                },
            })
        },
        getPlanList() {
            this.monitorList = []
            this.loading = true
            let data = {
                advertiserId: this.selectedAccount,
                smart_bid_type: 'SMART_BID_CUSTOM',
                pageIndex: 1,
                pageSize: 100
            }
            if (this.endTime) {
                data.create_start_date = this.startTime
            }
            if (this.startTime) {
                data.create_end_date = this.endTime
            }
            console.log(data, 'data------')
            this.$axios.post({
                url: 'uniPromotion/listByCondition',
                data,
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.planList = res.data.content
                        this.monitorList = this.planList
                        this.mergePlanWhiteListOptions(this.planList)
                        if (this.selectedMonitorList.length && this.activeWayBoxIndex == 1) {
                            let arr = []
                            this.selectedMonitorList.forEach((obj) => {
                                let adIndex = this.planList.findIndex((ad) => ad.adId == obj.adId)
                                if (adIndex !== -1) {
                                    arr.push(this.planList[adIndex])
                                }
                            })
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }

                    //          
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        getProductList(type) {
            this.checkAll = false
            this.selectedMonitorList = []
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.monitorList = []
            this.loading = true
            console.log(this.selectedAccount, this.selectedDYNumber)
            let object = {
                advertiserId: this.selectedAccount,
                aweMeId: this.selectedDYNumber,
                isAll: true,
            }
            console.log(object)
            this.$axios.post({
                url: '/launchTheProduct/getProductList',
                data: object,
                success: (res) => {
                    this.loading = false
                    console.log(res);
                    if (res.code === 0) {
                        console.log(res)
                        this.monitorList = res.data.productList
                        if (type) {
                            this.getdyNumberList(1)
                        }
                    } else {
                        this.$message.error(res.msg)
                        this.loading = false
                    }
                }
            })

        },
        getdyNumberList(type) {
            if (!type) {
                this.monitorList = []
            }

            this.loading = true
            this.$axios.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.selectedAccount,
                success: (res) => {
                    console.log(res, '222')
                    this.loading = false
                    if (res.code === 0) {
                        if (type) {
                            this.dyNumberList = res.data
                            return
                        }
                        this.monitorList = res.data
                    } else {
                        this.$message.error(res.msg || '获取数据错误')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        goSetStairsList() {
            if (!this.wholePayNum || this.wholePayNum == 0) return
            if (!this.stairsList.length) {
                let data = {
                    minValue: this.wholePayNum,
                    wholePayType: this.wholePayValue,
                    wholePayNum: '',
                    improveValue: '百分比提高',
                    roiImproveNum: '',
                }
                this.stairsList.push(data)
            } else {
                let endObj = this.stairsList[this.stairsList.length - 1]
                if (!endObj.wholePayNum || endObj.wholePayNum == 0) return
                let data = {
                    minValue: endObj.wholePayNum,
                    wholePayType: this.wholePayValue,
                    wholePayNum: '',
                    improveValue: '百分比提高',
                    roiImproveNum: '',
                }
                this.stairsList.push(data)

            }
        },
        goDelteteStairsList() {
            this.stairsList.pop()
        },
        addCondition() {
            this.executeConditionList.push({})
        },
        goDeleteCondition(index, choosedIndex) {
            this.executeConditionList.splice(index, 1)
            if (choosedIndex) {
                this.$set(this.executionList[choosedIndex], 'disabled', true)
            }
            console.log(this.executionList, 'obj==')
        },
        executeConditionChange(listIndex, index) {
            this.$set(this.executionList[listIndex], 'disabled', false)
            this.$set(this.executeConditionList[index], 'choosedIndex', JSON.stringify(listIndex))
            console.log(this.executionList, 'obj==')
            // console.log(obj, 'obj==')
        },
        selectTimeBox(num) {
            if (!this.timeSelectActiveList.includes(num)) {
                this.timeSelectActiveList.push(num)
            } else {
                let index = this.timeSelectActiveList.findIndex((obj) => obj == num)
                this.timeSelectActiveList.splice(index, 1)
            }
        },
        returnId(data) {
            this.selectIds = data;
            console.log(this.selectIds)
        },
        addCreateRule() {
            this.showAddCreateRulePopup = true;
        },
    }
}
</script>

<style scoped>
@import "../../styles/ocean-engine-rule-drawer.css";

* {
    /* font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol; */
}

.createRuleTitle {
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.setRuleContent {
    overflow: scroll;
    height: 90vh;
}


/* 营销目标 */

.marketingBox {
    padding: 8px 20px;
    color: #ddd;
    cursor: not-allowed;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-left: none;
    border-radius: 0 5px 5px 0;
}

.marketingObjectives_box div:first-child {
    border-radius: 5px 0 0 5px;
}

.activeMarketingBox {
    background-color: #409eff;
    color: #fff;
}



.monitorWayBox,
.monitorTargetBox {
    padding: 14px 20px;
}

.monitorWayBox i {
    color: #409eff;
}

.monitorWayBox .way_box {
    font-size: 14px;
    cursor: pointer;
    width: 220px;
    /* height: 80px; */
    padding: 20px 0;
    border: 1px solid #ddd;
    color: #333;
    border-radius: 5px;
}

.monitorWayBox .way_info {
    color: #666;
}

.active_way_box {
    border-color: #346bf6 !important;
    color: #346bf6 !important;
}

.monitorTargetBox .monitorTargetContent {
    background-color: #f9f9f9;
    border-radius: 5px;
    padding: 15px;
}


/deep/ .elBtn {
    border-radius: 0 50px 50px 0;
    height: 36px;
    width: 70px;
}

.handle-input2 {
    width: 300px !important;
    height: 36px;
    box-sizing: border-box;
}


/deep/ .handle-input2 .el-input__inner {
    height: 36px !important;
    box-sizing: border-box;
}

.selectTitleBox .leftTitle,
.rightTitle {
    font-size: 17px !important;
    /* font-weight: 600 !important; */
    width: 50%;
    background-color: #f0f2f5;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
}

.selectContentBox {
    background-color: #fff;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}

.selectContentBox .accountBox {
    height: 30px;
}

.selectContentBox .left {
    width: 50%;
    padding: 10px;
    height: 250px;
    overflow: scroll;
}

.selectedAccountBox {
    background-color: #edf4ff;
    padding: 10px;
}

.selectedAccountBox i {
    color: #409eff;
    cursor: pointer;
}

.yuan_box {
    position: absolute;
    top: 5px;
    right: 5px;
}

.addCondition {
    background-color: #edf4ff;
    padding: 5px 0;
    width: 500px;
    color: #4389f9;
    cursor: pointer;
}

.w100 {
    width: 100px;
}

.w150 {
    width: 150px;
}



.yl-time-range-table {
    border-collapse: collapse;
    table-layout: fixed;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 4px;
    width: 573px;
    border: 1px solid #e4e9ed;
    background-color: #fff;
}

.table_head {
    background-color: #f0f2f5;
    color: #555;
    /* padding: 10px; */
    text-align: center;
}

.time_select_box {
    cursor: pointer;
}

.time_select_box_inactive:hover {
    background-color: #f0f2f5;
}

.time_select_box_active {
    background-color: #409eff;
}

.drawer_footer {
    z-index: 1;
    background: #fff;
    align-items: center;
    height: 64px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -4px 6px #00000014;
}

.content_box1 {
    border: 1px dashed #ccc;
    padding: 20px 30px;

}

.currentPeriodBox {
    background-color: #e5ebf9;
    padding: 5px 10px;
    border-radius: 5px;
}

.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}



.exUserBox {
    border: 1px solid #ccc;
    height: 250px;
    box-sizing: border-box;
    /* padding-top: 50px; */
    /* overflow: scroll; */
    width: 500px;
    background-color: #fff;

}

.exUserBox .topTitle {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    background-color: #e4eeff;
    border-bottom: 1px solid #ccc;
}

.exUserBox .topTitle div {
    width: 250px;
    height: 50px;
    /* padding-left: 20px; */
    text-align: center;
    box-sizing: border-box;
    line-height: 50px;
}

.exUserBox .topTitle div:first-child {
    border-right: 1px solid #ccc;
}

.qrcodeBox {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAADECAMAAAD3eH5ZAAAAVFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5OTlxcXEAAABmZmZ2dnaQkJCOjo7x8fH09PSXl5f6+vr8/Pz+/v7///+YmJj///+ZmZn///+SQT0dAAAAGnRSTlMAAQIDBAUGBwgJCQkKCg0+P1pfkZat4OPu+FYhr8AAAALxSURBVHja7d1Lc6swDAVgEiSZtukjTdqk4v//z7vgZYxNMncBsuecdcLoG9ksOVVVaA6mk/v8z0gOWaUAQpyR/Olx9zytMDn9Q8u64Wg0a4o0oTaRNCNlsDX/UpJQRAjDP8lEAkcMsTSEAN4tISSpCA2TgM1kcoSKBWI0jAIxkdERUcQMHqF7gNs9I8RnBIqYoSd0D2l2zQTpGAvFDDEZOoI3/8tu8SQDI1TEEO+Xu6Zy2izJEe6X9xVEb6CLptNulpUhLjRXBIuo65rorl/izrfWYG5nJ196p17hrWK2CCJWlddrazTXV1FlonAVwSJY1Zk1tO3V9Yg6iSBiVj23hnNW5WEVIWJchKjeLCNuqhKsYo4gYpYt30H/996SYBULhOSAkDiiP03M4uwjnDD752mGIGLJAzFfRZkIlwPCrSGYxTX2EU1/KZaI4TTlgRhWURzCuxJZIOaXokxEkwOiKR3BLK55sY94Cd6xQAABBBBAbIk4tcZzAgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggACiVAS+UgoEEEBYQ+Bb+5YQ6J/YF4FOFkOIIip+iilbQneXEUTuVXBFlPIVVI+Ye1FlEZWhxZS35l+jO65CVSwXGotqpNA4rJZWZRH38f3z+2cJ8Pf78/3hRFg1Ui0dlnzf9bPvKZ86yk+7Zeor77vKP/X+RFP5Wsn3djXrayXfa4he8bZSt75d3f1K3frbWvH9uIuaiIiZRaQ7Vzunm4OZiZa19z0iUPiMAbJ3mAPCwuAhJkVNo8NEaCCEhgiiU3SMzrEzZpqhngi+YUBEFD3Dh+yZYZpj2jBDjIzRYSXHCMFDBIqRYUbiDXRIGRYKn2EqhxXDUmEQEhmxqh4qrFiSo1XV0wqzqWIpgJCVo3qY3OfPM/8ACadI/HzwP7wAAAAASUVORK5CYII=) no-repeat;
    justify-content: center;
    align-items: center;
    width: 198px;
    height: 198px;
    display: flex;
}


.qrcodeBox img {
    height: 140px;
    width: 140px;
}


/deep/ .selectContentBox .el-checkbox__inner {
    margin-bottom: 15px !important;
}

/deep/ .input100 .el-input__inner {
    width: 100px;
}

/deep/ .input150 .el-input__inner {
    width: 150px;
}

/deep/ .input200 .el-input__inner {
    width: 200px;
}

@media (max-width: 768px) {

    .monitorWayBox,
    .monitorTargetBox {
        padding: 15px;
    }

    .monitorWayBox .way_box {
        width: 31vw;
        box-sizing: border-box;
        height: 100px;
        /* height: 80px; */
        padding: 10px 5px;
    }


    .handle-input2 {
        font-size: 14px;
        width: 200px !important;
        height: 36px;
        box-sizing: border-box;
    }


    .addCondition {
        width: 300px;
    }

    .yl-time-range-table {
        width: 300px;
    }

    .dateSelector {
        transform: scale(0.8) !important;
        margin-left: -40px !important;
    }

    .productImg {
        height: 30px;
        width: 30px;
    }

    .selectedAccountBox {
        padding: 3px;
    }
}
</style>
